import { FONT_FAMILY_VARIANTS } from '@/components/Typography/constants.js';
import { Heading } from '@/components/Typography/Heading.js';
import { styled } from '@/stitches/index.js';

export const Container = styled('section', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '$32',
  margin: '$120 auto',
});

export const Title = styled(Heading, {
  fontFamily: '$heading',
  fontSize: '$36',
  lineHeight: 1.2,
  variants: {
    fontFamily: {
      ...FONT_FAMILY_VARIANTS,
      generalSans: {
        fontWeight: '$semiBold',
      },
      panchang: {
        '@bp0': {
          fontSize: '$20',
        },
        '@bp2': {
          fontSize: '$32',
        },
        '@bp4': {
          fontSize: '$40',
        },
      },
      switzer: {
        fontWeight: '$medium',
      },
      syne: {
        fontWeight: '$medium',
      },
      zodiak: {
        fontWeight: '$regular',
      },
    },
  },
  // eslint-disable-next-line canonical/sort-keys
  '@bp1': {
    fontSize: '$64',
  },
  marginBottom: 0,
  textAlign: 'center',
});
